import { EditorState } from '@tiptap/pm/state';
import { ElementType } from '../../../elements/elementTypes';
import { UniversalCardConverterCommand } from './universalCardTypes';

import { isValidColorFormat } from '../../../colors/colorSpaceUtil';
import { ColorObject, parseColorObject } from '../../../colors/colorObjectUtil';
import { getColorName } from '../../../colors/colorNameUtil';
import convertSimpleStringToTiptapContent from '../../utils/createJsonContentUtils/convertSimpleStringToTiptapContent';
import { TiptapContent } from '../../tiptapTypes';
import {
    COLOR_SWATCH_DEFAULT_HEIGHT_GRID,
    COLOR_SWATCH_DEFAULT_WIDTH_GRID,
} from '../../../colorSwatches/colorSwatchesConstants';

// TODO - Grid is currently in /client - so to avoid client dependencies we're defining a const here
const GRID_LARGE_SIZE = 10;

/**
 * Determines if the current editor text is only colour text.
 */
export const isOnlyColorText = (state: EditorState): boolean => {
    if (state.doc.content.childCount !== 1) return false;
    return !!isValidColorFormat(state.doc.textContent);
};

export const INITIAL_SWATCH_PROPERTIES = {
    width: COLOR_SWATCH_DEFAULT_WIDTH_GRID,
    media: {
        height: GRID_LARGE_SIZE * COLOR_SWATCH_DEFAULT_HEIGHT_GRID,
        width: GRID_LARGE_SIZE * COLOR_SWATCH_DEFAULT_WIDTH_GRID,
    },
    showColorValue: true,
    showCaption: true,
};

export const getSwatchPropertiesFromText = (
    text: string,
): { originalText: string; color: ColorObject; caption: TiptapContent } | null => {
    const color = parseColorObject(text);
    if (!color) return null;

    const colorName = getColorName(color) || '';
    const tiptapCaption = convertSimpleStringToTiptapContent(colorName);

    return {
        originalText: text,
        color,
        caption: tiptapCaption,
    };
};

export const attemptColorSwatchConversion: UniversalCardConverterCommand = ({
    state,
    updateCurrentlyEditingElementType,
}) => {
    if (!isOnlyColorText(state)) return null;

    const data = getSwatchPropertiesFromText(state.doc.textContent);

    if (!data) return null;

    // TODO Ensure the editor component doesn't force an update event now that we're
    //  changing the component type

    return updateCurrentlyEditingElementType({
        elementType: ElementType.COLOR_SWATCH_TYPE,
        data,
    });
};
